<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!-- <search id="header-search" class="right-menu-item" /> -->
        <span style="color: cadetblue; font-size: 12px" class="right-menu-item hover-effect"
          >Hi! {{ name }}</span
        >
        <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <!-- <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <!-- <el-badge :value="messageCount" class="item" v-if="messageCount > 0">
            <img :src="avatar ? avatar : defaultAvatar" class="user-avatar" />
            <i class="el-icon-caret-bottom"
          /></el-badge> -->

          <el-badge v-if="messageCount > 0 || faultBackCount > 0" is-dot class="item">
            <img :src="avatar ? avatar : defaultAvatar" class="user-avatar" />
            <i class="el-icon-caret-bottom"
          /></el-badge>

          <span v-else>
            <img :src="avatar ? avatar : defaultAvatar" class="user-avatar" />
            <i class="el-icon-caret-bottom" />
          </span>
        </div>
        <el-dropdown-menu slot="dropdown" style="padding: 5px 13px">
          <router-link to="/">
            <el-dropdown-item>首頁</el-dropdown-item>
          </router-link>

          <router-link to="/itaProfile/index">
            <el-dropdown-item>個人資料</el-dropdown-item>
          </router-link>

          <router-link to="/chat/index">
            <el-badge v-if="messageCount > 0" :value="messageCount" class="item">
              <el-dropdown-item>即時訊息</el-dropdown-item>
            </el-badge>
            <el-dropdown-item v-if="messageCount == 0">即時訊息</el-dropdown-item>
          </router-link>

          <router-link to="/educationResources/index">
            <el-dropdown-item>教學資源</el-dropdown-item>
          </router-link>

          <router-link to="/faultBack/index">
            <el-badge v-if="faultBackCount > 0" :value="faultBackCount" class="item">
              <el-dropdown-item>故障與回饋</el-dropdown-item>
            </el-badge>
            <el-dropdown-item v-if="faultBackCount == 0">故障與回饋</el-dropdown-item>
          </router-link>

          <!-- <a target="_blank" href="https://github.com/PanJiaChen/vue-element-admin/">
            <el-dropdown-item>Github</el-dropdown-item>
          </a>
          <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
            <el-dropdown-item>Docs</el-dropdown-item>
          </a> -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">登出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import summer from '@/assets/avatars/summer.gif'
// import italogo from "@/assets/images/italogo.png";
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
// import SocketNotice from "@/utils/socketNotice";
import { _uuid } from '@/utils/funcs'

var titleInterval = null
export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search,
  },
  data() {
    return {
      docTitle: '',
      defaultAvatar: '',
      agencyCode: null,
      content: null,
      docTitleRevert: false,
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'messageCount', 'name', 'faultBackCount']),
  },
  watch: {
    messageCount: {
      handler: function (newVal, oldVal) {
        let vm = this
        if (titleInterval) {
          clearInterval(titleInterval)
          titleInterval = null
          this.docTitle = document.title
        }

        if (newVal && newVal > 0) {
          titleInterval = setInterval(() => {
            if (vm.docTitleRevert) {
              document.title = vm.docTitle
            } else {
              document.title = '您有新的訊息!'
            }
            vm.docTitleRevert = !vm.docTitleRevert
          }, 1000)
        }
      },
      deep: true,
      immediate: true,
    },
    // faultBackCount: {
    //   handler: function (newVal, oldVal) {
    //     console.log("newVal", newVal);
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  created() {
    this.docTitle = document.title
    this.defaultAvatar = summer
    this.agencyCode = this.$store.getters.userInfo.agencyCode
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('app/showDialog', false)
      await this.$store.dispatch('app/showEscroll', false)
      await this.$store.dispatch('app/showNotify', false)
      await this.$store.dispatch('user/logout')
      if (titleInterval) {
        clearInterval(titleInterval)
        titleInterval = null
        document.title = this.docTitle
      }
      //https://admin.itainctw.com/login
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      https: this.$router.push(`/login`)
      let uuid = _uuid()
      let urlPath = `${location.origin}/login?iid=${uuid}`
      location.href = urlPath
      // window.location.reload();
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#1e5799+0,2989d8+50,207cca+51,7db9e8+100;Blue+Gloss+Default */
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#e4f5fc+0,bfe8f9+50,9fd8ef+83,2ab0ed+100 */
  background: #ffe483; /* Old browsers */
  // background: -moz-linear-gradient(
  //   -45deg,
  //   #e4f5fc 0%,
  //   #bfe8f9 50%,
  //   #9fd8ef 83%,
  //   #2ab0ed 100%
  // ); /* FF3.6-15 */
  // background: -webkit-linear-gradient(
  //   -45deg,
  //   #e4f5fc 0%,
  //   #bfe8f9 50%,
  //   #9fd8ef 83%,
  //   #2ab0ed 100%
  // ); /* Chrome10-25,Safari5.1-6 */
  // background: linear-gradient(
  //   135deg,
  //   #e4f5fc 0%,
  //   #bfe8f9 50%,
  //   #9fd8ef 83%,
  //   #2ab0ed 100%
  // ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e4f5fc', endColorstr='#2ab0ed',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */

  height: 50px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
